export const PAGE_TITLE_NEW_CAR_CONSUMERS_REVIEWS = 'Consumer Review';
export const REVIEW_RATE_TEXT_EXCELLENT = 'Excellent';
export const REVIEW_RATE_TEXT_GOOD = 'Good';
export const REVIEW_RATE_TEXT_AVAERAGE = 'Average';
export const REVIEW_RATE_TEXT_FAIR = 'Fair';
export const REVIEW_RATE_TEXT_POOR = 'Poor';
export const STAR_RATING_COUNT = 5;
export const TITLE_LENGTH_LIMIT = 150;
export const REVIEW_LENGTH_LIMIT = 2400;
export const WHAT_I_LIKE_LENGTH_LIMIT = 2400;
export const WHAT_I_DONT_LIKE_LENGTH_LIMIT = 2400;
export const DISCLAIMER_TEXT = 'Disclaimer: You remain solely responsible for the content of your messages, and you agree to indemnify and hold harmless this website and their agents with respect to any claim based upon any post you may submit.'; // @suppress longLineCheck
export const COMFORT_TEXT = 'Comfort';
export const HANDLING_TEXT = 'Handling';
export const RELIABILITY_TEXT = 'Reliability';
export const FEATURES_TEXT = 'Features';
export const INTERIOR_TEXT = 'Interior Design';
export const PERFORMANCE_TEXT = 'Engine Performance';
export const VALUE_TEXT = 'Value For Money';
export const EXTERIOR_TEXT = 'Exterior Styling';
export const ICON_SIZE_IN_PIXEL = 14;
export const STAR_ICON_SIZE_IN_PIXEL = 13;
export const TEXTBOX_ICON_SIZE_IN_PIXEL = 20;
export const DESKTOP_STAR_ICON_SIZE = 18;
export const MOBILE_STAR_ICON_SIZE = 20;
export const DESKTOP_TEXTAREA_ROW_COUNT = 5;
export const MOBILE_TEXTAREA_ROW_COUNT = 11;
export const RATING_TEXT_MAP = [
  REVIEW_RATE_TEXT_EXCELLENT,
  REVIEW_RATE_TEXT_GOOD,
  REVIEW_RATE_TEXT_AVAERAGE,
  REVIEW_RATE_TEXT_FAIR,
  REVIEW_RATE_TEXT_POOR,
];
